import React from 'react';

const PartnerWithPilotHelper = ({ organizationType = 'company', emailType = 'company' }) => {
    // Map organization types to their specific text
    const organizationText = {
        'company': 'your company',
        'college': 'your college or university',
        'flight-school': 'your flight school'
    };

    // Map email types to their specific text
    const emailTypeText = {
        'company': 'official company email address',
        'institutional': 'official institutional email address'
    };

    return (
        <section className="mb-4">
            <h2 className="mb-3">Partner with PilotHelper</h2>
            <p>
                If you are an authorized leader at {organizationText[organizationType]} and {organizationType === 'company' ? 'interested in partnering' : 'would like to partner'} with
                PilotHelper, email us from your {emailTypeText[emailType]} at{' '}
                <a 
                    href="mailto:contact@pilothelper.com" 
                    style={{
                        color: 'var(--light-blue)', 
                        textDecoration: 'none', 
                        fontWeight: 'bold'
                    }}
                >
                    contact@pilothelper.com
                </a>.
            </p>
        </section>
    );
};

export default PartnerWithPilotHelper;
